// extracted by mini-css-extract-plugin
module.exports = {"ButtonCopy":"ButtonCopy_ButtonCopy__1s37A","CopiedText":"ButtonCopy_CopiedText__2WkXT"};